import { computed, inject, onBeforeUnmount, onMounted, Ref, ref, nextTick } from 'vue';

export function useMenuItem(hasSubmenu: boolean, onlyLeft: boolean = false) {
  const openSubmenu = inject('openSubmenu') as Ref<string | null>;
  const setOpenSubmenu = inject('setOpenSubmenu') as (submenuId: string | null) => void;

  const submenuId = (new Date().getTime() * Math.random()).toString();
  const isSubmenuVisible = computed(() => openSubmenu.value === submenuId);
  const submenuRef = ref<HTMLElement | null>(null);
  const positionClass = ref('left-[calc(100%+12px)]');

  const handleMouseEnter = async () => {
    if (hasSubmenu) {
      setOpenSubmenu(submenuId);
      positionClass.value = 'left-[calc(100%+12px)]';
      await nextTick(adjustSubmenuPosition);
    } else {
      setOpenSubmenu(null);
    }
  };

  const handleOutsideClick = (event: MouseEvent) => {
    setOpenSubmenu(null);
  };

  const adjustSubmenuPosition = () => {
    if (!submenuRef.value) return;

    const rect = submenuRef.value.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    if (onlyLeft || rect.right > viewportWidth) {
      // If submenu overflows, position it to the left
      positionClass.value = 'right-[calc(100%+12px)]';
    } else {
      positionClass.value = 'left-[calc(100%+12px)]'; // Default to right
    }
  };

  onMounted(() => {
    document.addEventListener('click', handleOutsideClick);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', handleOutsideClick);
  });

  return {
    isSubmenuVisible,
    handleMouseEnter,
    submenuRef,
    positionClass,
  };
}
